import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

type Props = {
  tags: ReactNode
  info?: ReactNode
}

export const MembershipCell = ({ tags, info }: Props) => (
  <S.Container>
    <S.Tags>{tags}</S.Tags>
    {info && <S.Info>{info}</S.Info>}
  </S.Container>
)
